import { Component, OnInit } from '@angular/core';
import { RouteValidationService } from "../../../shared/route-validation.service";

import {
  BaseService,
} from '../../mesc/mesc.service';

@Component({
  selector: 'timing-charts',
  templateUrl: './timing-charts.component.html',
  // styleUrls: ['./timing-charts.component.scss']
  host: { 'class': 'router-outlet' },
})
export class TimingChartsComponent implements OnInit {
  selected: string = 'default';

  constructor(public routerValidationService: RouteValidationService) { }

  ngOnInit() {
    this.routerValidationService.selected$
      .subscribe(s => this.selected = s);
    this.routerValidationService.get();
  }

}
